export default "__VITE_ASSET__DQrJlmkx__"